export default class copyToClipboard {
	constructor()
	{
		this.copyButtons = document.querySelectorAll('.icon-list__copy');

		this.copyButtons && this.copyButtons.forEach((button) => {

			button.addEventListener("click", (event) => {

				event.preventDefault()
				
				navigator.clipboard.writeText(button.href);

				button.classList.add('success');
				button.dataset.tooltip = 'Copied!';

				setTimeout(() => {
					button.dataset.tooltip = 'Copy Link';
					button.classList.remove('success');
				},1000)

			});

		})

	}
}